import { Component, OnInit } from '@angular/core';
import {NgWizardConfig, NgWizardService, THEME} from 'ng-wizard';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Params} from '@angular/router';
import {NgxUiLoaderService} from 'ngx-ui-loader';

@Component({
  selector: 'app-request-search-detail',
  templateUrl: './request-search-detail.component.html',
  styleUrls: ['./request-search-detail.component.scss']
})
export class RequestSearchDetailComponent implements OnInit {
  public appRefNo: number;
  selectMenu=1;
  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows,
    toolbarSettings: {
      // toolbarExtraButtons: [
      //   { text: 'Finish', class: 'btn btn-info', event: () => { alert("Finished!!!"); } }
      // ]
    }};
  constructor(private route: ActivatedRoute,
              private modalService: NgbModal,
              private ngWizardService: NgWizardService,
              private spinnerService: NgxUiLoaderService) { }

  ngOnInit() {
    this.selectMenu==1;
    this.onGetIdFromUrl();
  }


  onGetIdFromUrl() {
    this.route.params.subscribe(
      (param: Params) => {
        this.appRefNo = param.requestId;
      }
    );
  }
}
